export function SectionCardSubsection(props) {
    return (
        <div
            className={`z-30 rounded-[3rem] lg:rounded-[5rem] xl:rounded-[7rem] py-16 px-12 lg:px-20 flex flex-col w-full justify-start items-center lg:flex-row lg:items-start mb-12 lg:mb-0 ${
                props.className ? props.className : ""
            }`}
        >
            {props.children}
        </div>
    );
}
